module.exports = __webpack_public_path__ + "static/media/target.91304f4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/actions/target.svg
// module id = 102
// module chunks = 0